export const PAGE_PATH = {
  NOTICE_BANNER: '/content/notice-banner',
  HOME: {
    INFO_GUIDES_CAROUSEL: '/content/info-guides-carousel',
    ENABLING_BUSINESS_CAROUSEL: '/content/enabling-your-business-carousel',
  },
  ANNOUNCEMENT: {
    BUY_INFORMATION: '/content/buyinfo-announcement-carousel',
    SUBSCRIBE_APIS: '/content/subscribe-announcement-carousel',
  },
};
